export enum ModelTypeEnum {
  OTHERS_VISITED = 'others-visited',
  SIMILAR_PRODUCTS = 'similar-products',
  PERSONALIZED = 'personalized',
}

export type ModelType =
  | ModelTypeEnum.OTHERS_VISITED
  | ModelTypeEnum.SIMILAR_PRODUCTS
  | ModelTypeEnum.PERSONALIZED;
